import * as z from "zod";

export const GoogleAdsConnectionSchema = z.object({
  redoSegment: z.object({ name: z.string(), id: z.string() }),
  googleAdsCustomerList: z.object({ name: z.string(), id: z.string() }),
});

export type GoogleAdsConnection = z.infer<typeof GoogleAdsConnectionSchema>;
